/**
 * Per-model list-column configuration.
 *
 * Drives the extra columns that `ModelListView` and `DAGSubListView` render
 * beyond the universal Name / ID / Created shape. This file is intentionally
 * *not* generated — column choice is a UI concern, independent of the
 * backend model's shape, so it lives in the frontend app rather than being
 * inferred from Python `NeoField` annotations.
 *
 * Shape: `modelName → ordered list of field names`.
 *
 * Unlisted models fall back to the default Name / ID / Created columns.
 *
 * When a model gains a new field you want to surface in lists, just add it
 * here — no codegen run or backend restart required.
 */

export const listColumnsByModel: Record<string, readonly string[]> = {
  // RFLP — Requirements / Functional / Logical / Physical.
  // Long-text fields like `description` truncate with a native title-attribute
  // tooltip; short scalar / enum fields render untruncated within max-w-xs.
  Requirement: ["category", "priority", "status", "target_milestone", "description"],
  Action: ["kind", "function_verb", "verdict", "description"],
  LogicalPart: ["kind", "description"],
  PhysicalPart: ["manufacturer", "part_number", "sourcing_status", "cost", "description"],
  // a check that could not see everything says Complete: No, beside its
  // total, so an empty total never reads as passed (vc-impl a05ef33f8)
  AnalysisRecord: ["run_at", "complete", "total", "summary"],

  // Add other modules' column preferences here as they get polished.
};

/**
 * Returns the list of field names to render as extra columns for this model,
 * or `undefined` if the model hasn't opted in (the view then falls back to
 * the default column set).
 */
export function getListColumns(modelName: string): readonly string[] | undefined {
  return listColumnsByModel[modelName];
}
